import React, { Component } from 'react';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';
import { getActChild } from '../../../helpers/ActChildren';

const getTextAlign = (align) => {
	switch (align) {
		case 'do-prawej':
			return 'right';
		case 'do-lewej':
			return 'left';
		case 'do-srodka':
			return 'center';
		default:
			return 'left';
	}
};

const getVerticalAlign = (align) => {
	switch (align) {
		case 'do-gory':
			return 'top';
		case 'do-srodka':
			return 'middle';
		case 'do-dolu':
			return 'bottom';
		default:
			return 'top';
	}
};

export class ActElementTd extends Component {
	render() {
		const {
			childrens,
			text,
			attributes,
			showComment,
			canCommentAndSetOpinion,
			showOpinion = false,
			isCommentAdding = false
		} = this.props;
		const {
			fontSize,
			horizontalAlign,
			horizontalSpan,
			isBorderBottom,
			isBorderLeft,
			isBorderRight,
			isBorderTop,
			verticalAlign,
			verticalSpan,
			width
		} = attributes;

		return (
			<td
				colSpan={horizontalSpan}
				rowSpan={verticalSpan}
				className={`${isBorderLeft ? 'act__td--border-left ' : ''}${isBorderRight
					? 'act__td--border-right '
					: ''}${isBorderTop ? 'act__td--border-top ' : ''}${isBorderBottom ? 'act__td--border-bottom' : ''}`}
				style={{
					textAlign: getTextAlign(horizontalAlign),
					verticalAlign: getVerticalAlign(verticalAlign),
					width
				}}
			>
				<span
					className="text text--line-1"
					dangerouslySetInnerHTML={{ __html: text }}
					style={{
						fontSize
					}}
				/>
				{map(orderBy(childrens, (c) => c.order), (child) =>
					getActChild(child, {
						canCommentAndSetOpinion,
						showComment,
						saveComment: (comment) => this.props.saveComment(comment),
						showOpinion,
						isCommentAdding
					})
				)}
			</td>
		);
	}
}
